import notFoundIcon from '@assets/svg/icon/not-found.svg';
import { newToastMessageAsync, removeToastMessage, updateToastMessage } from '../ToastMessagesActions';
import { poorNetworkConnectionMessage, poorNetworkConnectionMessageActive } from '../ToastMessagesSelectors';
import { poorNetMsg, badNetTitle } from '../ToastMessagesConstants';

export const removingAllPoorNetToastMessagesType = 'REMOVING_ALL_POOR_NET_TOAST_MESSAGES_TYPE';

export function removingAllPoorNetToastMessages() {
  return {
    type: removingAllPoorNetToastMessagesType,
  };
}

export class PoorNetMessagesQueue {
  queue = [];

  clear() {
    this.queue = [];
  }

  addAction = async (dispatch, getState) => {
    this.queue.push(this.createShowMessageFunc(dispatch));
    return this.tryToShowNextMessage(getState);
  };

  tryToShowNextMessage(getState) {
    if (this.queue.length === 0) {
      return;
    }
    if (!(this.queue[0] instanceof Promise)) {
      this.queue[0] = this.queue[0]().then(() => {
        this.queue.shift();
        const prevMessage = poorNetworkConnectionMessage(getState());

        if (prevMessage && !prevMessage.removingInProgress) {
          this.tryToShowNextMessage(getState);
        } else {
          this.clear();
        }
      }).catch(Logger.reject);
    }
  }

  showMessageAction = async (dispatch, getState) => {
    const {count, id: prevMessageId} = poorNetworkConnectionMessageActive(getState()) || {count: 0};
    const nextCount = count + 1;
    const action = newToastMessageAsync({
      title: badNetTitle,
      content: poorNetMsg(nextCount),
      iconId: notFoundIcon.url,
      poorNetworkConnection: true,
      count: nextCount,
    });

    prevMessageId && dispatch(updateToastMessage(prevMessageId, {
      className: 'poor-net-toast-message-fade-out-under-next-message',
    }));

    await dispatch(action);

    prevMessageId && dispatch(removeToastMessage(prevMessageId));
  };

  createShowMessageFunc(dispatch) {
    return () => dispatch(this.showMessageAction);
  }
}

export const queue = new PoorNetMessagesQueue();

export function poorNetworkConnectionToastMessage() {
  return queue.addAction;
}
